function SummaryHeader({
  sumPoints,
  numQuestions,
  index,
  answer,
  maxPossiblePoints,
}) {
  return (
    <header className="progress">
      <progress max={numQuestions} value={index + Number(answer !== null)} />

      <p>
        Question <strong>{index + 1}</strong> / {numQuestions}
      </p>

      <p>
        <strong>{sumPoints}</strong> / {maxPossiblePoints}
      </p>
    </header>
  );
}

export default SummaryHeader;
